import { render, staticRenderFns } from "./bannerlist.vue?vue&type=template&id=312b33c3&"
import script from "./bannerlist.vue?vue&type=script&lang=js&"
export * from "./bannerlist.vue?vue&type=script&lang=js&"
import style0 from "./bannerlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports